import { useState } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const useIsPlayerStarted = () => {
    const instance = usePlayerInstance();
    const [isStarted, setIsStarted] = useState<boolean>(() => !!instance?.isStarted);

    useInstanceEffect((instance) => instance.onIsStartedChange(setIsStarted));

    return isStarted;
};
